import AddFacility from "./AddFacilityIcon"
import AddUserIcon from "./AddUserIcon"
import AlertIcon from "./AlertIcon"
import AlertsIcon from "./AlertsIcon"
import ArrowDownIcon from "./ArrowDownIcon"
import ArrowLeftIcon from "./ArrowLeftIcon"
import ArrowRightIcon from "./ArrowRightIcon"
import ArrowUpIcon from "./ArrowUpIcon"
import BatteryChargingIcon from "./BatteryChargingIcon"
import BatteryEmptyIcon from "./BatteryEmptyIcon"
import BatteryFullIcon from "./BatteryFullIcon"
import BatteryHalfIcon from "./BatteryHalfIcon"
import BatteryLowIcon from "./BatteryLowIcon"
import BlockIcon from "./BlockIcon"
import BrokenWatchIcon from "./BrokenWatchIcon"
import BroomIcon from "./BroomIcon"
import BrushIcon from "./BrushIcon"
import BuildingIcon from "./BuildingIcon"
import CalendarIcon from "./CalendarIcon"
import CellCustomIcon from "./CellCustomIcon"
import CellIcon from "./CellIcon"
import CellWithDoorSensorIcon from "./CellWithDoorSensorIcon"
import CheckmarkIcon from "./CheckmarkIcon"
import CityIcon from "./CityIcon"
import ClearAlertsIcon from "./ClearAlertsIcon"
import ClockIcon from "./ClockIcon"
import ConnectedIcon from "./ConnectedIcon"
import CrossIcon from "./CrossIcon"
import DetailViewIcon from "./DetailViewIcon"
import DisconnectedIcon from "./DisconnectedIcon"
import DownloadIcon from "./DownloadIcon"
import DynamicIcon from "./DynamicIcon"
import EditIcon from "./EditIcon"
import EnterEventIcon from "./EnterEventIcon"
import EnvelopeIcon from "./EnvelopeIcon"
import FacilityIcon from "./FacilityIcon"
import FlagIcon from "./FlagIcon"
import FloorIcon from "./FloorIcon"
import GatewayIcon from "./GatewayIcon"
import GraphIcon from "./GraphIcon"
import GripDotsIcon from "./GripDotsIcon"
import GuardUserIcon from "./GuardUserIcon"
import HeartRateIcon from "./HeartRateIcon"
import HiddenIcon from "./HiddenIcon"
import HumanPresenceIcon from "./HumanPresenceIcon"
import InfoIcon from "./InfoIcon"
import InmateIcon from "./InmateIcon"
import LastReadIcon from "./LastReadIcon"
import LocationIcon from "./LocationIcon"
import LockIcon from "./LockIcon"
import LogoffIcon from "./LogoffIcon"
import LowerThresholdIcon from "./LowerThresholdIcon"
import MailIcon from "./MailIcon"
import MaintenanceIcon from "./MaintenanceIcon"
import ManagementUserIcon from "./ManagementUserIcon"
import MedicalUserIcon from "./MedicalUserIcon"
import MessageIcon from "./MessageIcon"
import MicrosoftIcon from "./MicrosoftIcon"
import MoveInmateIcon from "./MoveInmateIcon"
import MovementIcon from "./MovementIcon"
import MuteIcon from "./MuteIcon"
import NextIcon from "./NextIcon"
import NoVitalSignIcon from "./NoVitalSignIcon"
import OutOfBoundsIcon from "./OutOfBoundsIcon"
import OverrideIcon from "./OverrideIcon"
import OxygenLevelIcon from "./OxygenLevelIcon"
import PlayIcon from "./PlayIcon"
import PlusIcon from "./PlusIcon"
import PositionIcon from "./PositionIcon"
import PreferencesIcon from "./PreferencesIcon"
import RecalibrateIcon from "./RecalibrateIcon"
import ResetIcon from "./ResetIcon"
import RespiratoryRateIcon from "./RespiratoryRateIcon"
import RiskIcon from "./RiskIcon"
import SafeIcon from "./SafeIcon"
import SaveIcon from "./SaveIcon"
import ScanWearableIcon from "./ScanWearableIcon"
import SearchIcon from "./SearchIcon"
import SensorIcon from "./SensorIcon"
import SetOccupiedIcon from "./SetOccupiedIcon"
import SettingsIcon from "./SettingsIcon"
import SetVacantIcon from "./SetVacantIcon"
import ShareIcon from "./ShareIcon"
import ShieldIcon from "./ShieldIcon"
import SmartwatchIcon from "./SmartwatchIcon"
import SnoozeAlertIcon from "./SnoozeAlertIcon"
import SnoozeIcon from "./SnoozeIcon"
import SortByIcon from "./SortByIcon"
import SoundIcon from "./SoundIcon"
import SpeakerIcon from "./SpeakerIcon"
import StaticIcon from "./StaticIcon"
import StreetIcon from "./StreetIcon"
import SupportIcon from "./SupportIcon"
import TemperatureIcon from "./TemperatureIcon"
import TenantAdminIcon from "./TenantAdminIcon"
import ThresholdIcon from "./ThresholdIcon"
import TimezoneIcon from "./TimezoneIcon"
import TrashBinIcon from "./TrashBinIcon"
import TriangleIndicatorIcon from "./TriangleIndicatorIcon"
import UnknownLocationIcon from "./UnknownLocationIcon"
import UnlinkedIcon from "./UnlinkedIcon"
import UploadIcon from "./UploadIcon"
import UpperThresholdIcon from "./UpperThresholdIcon"
import VisualIcon from "./VisualIcon"
import WarningIcon from "./WarningIcon"
import YardIcon from "./YardIcon"

const icons = {
   addFacility: AddFacility,
   addUser: AddUserIcon,
   alert: AlertIcon,
   alerts: AlertsIcon,
   arrowDown: ArrowDownIcon,
   arrowLeft: ArrowLeftIcon,
   arrowRight: ArrowRightIcon,
   arrowUp: ArrowUpIcon,
   batteryCharging: BatteryChargingIcon,
   batteryEmpty: BatteryEmptyIcon,
   batteryFull: BatteryFullIcon,
   batteryHalf: BatteryHalfIcon,
   batteryLow: BatteryLowIcon,
   block: BlockIcon,
   brokenWatch: BrokenWatchIcon,
   broom: BroomIcon,
   brush: BrushIcon,
   building: BuildingIcon,
   calendar: CalendarIcon,
   cellCustom: CellCustomIcon,
   cell: CellIcon,
   cellWithDoorSensor: CellWithDoorSensorIcon,
   checkmark: CheckmarkIcon,
   city: CityIcon,
   clearAlerts: ClearAlertsIcon,
   clock: ClockIcon,
   connected: ConnectedIcon,
   cross: CrossIcon,
   detailView: DetailViewIcon,
   disconnected: DisconnectedIcon,
   download: DownloadIcon,
   edit: EditIcon,
   enterEvent: EnterEventIcon,
   envelope: EnvelopeIcon,
   facility: FacilityIcon,
   flag: FlagIcon,
   floor: FloorIcon,
   gateway: GatewayIcon,
   graph: GraphIcon,
   gripDots: GripDotsIcon,
   guardUser: GuardUserIcon,
   heartRate: HeartRateIcon,
   hidden: HiddenIcon,
   dynamic: DynamicIcon,
   humanPresence: HumanPresenceIcon,
   info: InfoIcon,
   inmate: InmateIcon,
   lastRead: LastReadIcon,
   location: LocationIcon,
   lock: LockIcon,
   logoff: LogoffIcon,
   lowerThreshold: LowerThresholdIcon,
   mail: MailIcon,
   maintenance: MaintenanceIcon,
   managementUser: ManagementUserIcon,
   medicalUser: MedicalUserIcon,
   message: MessageIcon,
   microsoft: MicrosoftIcon,
   moveInmate: MoveInmateIcon,
   mute: MuteIcon,
   movement: MovementIcon,
   next: NextIcon,
   noVitalSign: NoVitalSignIcon,
   outOfBounds: OutOfBoundsIcon,
   override: OverrideIcon,
   oxygenLevel: OxygenLevelIcon,
   play: PlayIcon,
   plus: PlusIcon,
   position: PositionIcon,
   preferences: PreferencesIcon,
   recalibrate: RecalibrateIcon,
   reset: ResetIcon,
   respiratoryRate: RespiratoryRateIcon,
   risk: RiskIcon,
   safe: SafeIcon,
   save: SaveIcon,
   scanWearable: ScanWearableIcon,
   search: SearchIcon,
   sensor: SensorIcon,
   setOccupied: SetOccupiedIcon,
   settings: SettingsIcon,
   setVacant: SetVacantIcon,
   share: ShareIcon,
   shield: ShieldIcon,
   smartwatch: SmartwatchIcon,
   snoozeAlert: SnoozeAlertIcon,
   snooze: SnoozeIcon,
   sortBy: SortByIcon,
   sound: SoundIcon,
   speaker: SpeakerIcon,
   static: StaticIcon,
   street: StreetIcon,
   support: SupportIcon,
   temperature: TemperatureIcon,
   tenantAdmin: TenantAdminIcon,
   threshold: ThresholdIcon,
   timezone: TimezoneIcon,
   trashBin: TrashBinIcon,
   triangleIndicator: TriangleIndicatorIcon,
   unknownLocation: UnknownLocationIcon,
   unlinked: UnlinkedIcon,
   upload: UploadIcon,
   upperThreshold: UpperThresholdIcon,
   visual: VisualIcon,
   warning: WarningIcon,
   yard: YardIcon,
}

export default icons
